import React, { Component } from 'react';
import Roi from './Roi';
import t from '../../utils/translations';
import { isIntegrated } from '../../utils/fn';

if (!isIntegrated()) {
  import('./App.scss');
}

class App extends Component {

  state = {
    loading: true,
    error: false,
    roi: {
      products: [],
      default_values: {},
      prepend_symbol: '',
      append_symbol: '',
    },
  };

  componentDidMount() {
    const url = new URL(this.props.appArgs.rest.getProducts);
    url.searchParams.append('skipProductEnabledOption', this.props.appArgs.skipProductEnabledOption);
    fetch(url.toString())
      .then(response => response.json())
      .then(result => {
        if (result.products.length !== 0) {
          this.setState({
            roi: result,
            loading: false,
          });
        } else {
          this.setState({
            loading: false,
            error: true,
          });
        }
      });
  }

  render() {
    if (!this.state.loading && this.state.error) {
      return (
        <p className="text-center">{t('Something went wrong. Please try again later!')}</p>
      );
    } else if (this.state.loading) {
      return (<p className="text-center">{t('Loading product data...')}</p>);
    } else {
      if (this.state.roi.products?.length) {
        const product = this.state.roi.products.find(product => product.id === this.props.appArgs.productId);
        return (<Roi {...this.state.roi} product={product || this.state.roi.products[0]}/>);
      } else {
        console.warn(`No products found. Skipping rendering ROI`);
        return null;
      }
    }
  }
}

export default App;
